import { ALERT_STATE_UI, ALERT_STATES } from '@baseline/shared';

/** The alert state a dashboard stage (`statusKey`) filters the list by. */
export function stateForStatusKey(statusKey: string): string | null {
  return ALERT_STATES.find((s) => ALERT_STATE_UI[s].statusKey === statusKey) ?? null;
}
